let inFlight = null;

/**
 * Opens the native share sheet with the page URL, or copies it.
 * Concurrent calls are ignored.
 *
 * @param {{ url?: string }} [data]
 */
export async function share(data = {}) {
  if (typeof navigator === "undefined") {
    return;
  }

  if (inFlight) {
    return inFlight;
  }

  inFlight = (async () => {
    const url = data.url || window.location.href;

    try {
      if (typeof navigator.share === "function") {
        await navigator.share({ url });
        return;
      }

      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      }
    } catch (error) {
      if (error?.name === "AbortError" || error?.name === "InvalidStateError") {
        return;
      }
      console.error("Share failed:", error);
    }
  })().finally(() => {
    inFlight = null;
  });

  return inFlight;
}
